import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { startDateModStyles } from '../StartDate/StartDateMod.styles';
import { useSelector } from 'react-redux';
import { selectCurrentModDetails, selectInitiators, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import moment from 'moment';
import { InitiatedBy } from '../StartDate/InitiatedBy';
import { NewEndDate } from './NewEndDate';

export const EndDateMod = () => {
  const { t } = useTranslation();
  const { classes } = startDateModStyles();
  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const initiators = useSelector(selectInitiators);
  const isModEdit = useSelector(selectIsEditMod);

  return (
    <>
      <Grid spacing={4} container height="370px">
        <Grid item xs={12}>
          <Grid className={classes.labelRow}>
            <Typography component="span" className={classes.labelFont}>{`${t(
              'placement.placementMods.currentStartDate',
            )}`}</Typography>
            <Typography component="span">
              {selectedModsDetails?.currentStartDate
                ? moment(selectedModsDetails?.currentStartDate)?.format('MM/DD/YYYY')
                : '--'}
            </Typography>
          </Grid>
          <Grid className={classes.labelRow}>
            <Typography component="span" className={classes.labelFont}>{`${t(
              'placement.placementMods.currentEndDate',
            )}`}</Typography>
            <Typography component="span">
              {selectedModsDetails?.currentStartDate
                ? moment(selectedModsDetails?.currentEndDate)?.format('MM/DD/YYYY')
                : '--'}
            </Typography>
          </Grid>

          <div className={classes.root}>
            <Grid container spacing={4} className={classes.gridContainer}>
              <Grid item xs={12} className={classes.dateContainer}>
                <NewEndDate />
              </Grid>

              <Grid item xs={12} className={classes.dateContainer}>
                <InitiatedBy options={initiators} isModEdit={isModEdit} />
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </>
  );
};
